export default __webpack_public_path__ + "static/media/icon_close.bf950784.svg";